import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { ACCOMMODATIONS_ACTIVITIES_OVERVIEW,RENTAL_ITEMS_OVERVIEW } from '../../../graphql/queries/accommodations-activities-overview';


const useOverview = businessOwnerId => {
  const { data, ...props } = useQuery(ACCOMMODATIONS_ACTIVITIES_OVERVIEW, {
    variables: { businessOwnerId }
  });

  const { data : rental, ...props1} = useQuery(RENTAL_ITEMS_OVERVIEW, {
    variables: { businessOwnerId }
  });
 
  
const overview = {
    accommodations: data?.accommodationsActivitiesOverview?.accommodations,
    activities: data?.accommodationsActivitiesOverview?.activities,
    rental:rental?.rentalItemsOverview?.rentalItems
  };


  return {
    overview,
    ...props,
    ...props1
  };
};

export default useOverview;
